export const saveProfile = {
    data() {
        return {

        }
    },
    methods: {
         save(callback=false, partial=false) {
            this.$validator.validateAll()
            .then((valid) => {
                if (valid) {
                    if (
                        !this.localUser['avatar'] ||
                        this.localUser['avatar'].startsWith('/media') ||
                        this.localUser['avatar'].startsWith('http')
                    ) {
                        delete this.localUser['avatar'];
                    }
                    this.$store.dispatch(
                        'user/saveProfile',
                        [this.localUser, partial]
                    )
                    .then(() => {
                        if (callback) {
                            callback();
                        }
                    })
                    .catch((err) => {
                        this.buttonLoader = false;
                        for (let key in this.userErrors) {
                            if (
                                key == 'educations' ||
                                key == 'careers' ||
                                key == 'military_services'
                            ) {
                                for (let i in this.userErrors[key]) {
                                    if (Object.keys(
                                        this.userErrors[key][i]
                                    ).length) {
                                        for (let j in this.userErrors[key][i]) {
                                            this.errors.add({
                                                field: key + '_' + j + '_' + i,
                                                msg: this.userErrors[key][i][j][0]
                                            });
                                        }
                                    }
                                }
                            } else {
                                this.errors.add({
                                    field: key,
                                    msg: this.userErrors[key][0]
                                });
                            }
                        }
                    });
                }
            });
        },
    }
}
